import React from 'react'
import tw from 'tailwind-styled-components'
import {Header} from './header'
import {Meta} from './meta'

const TwTile = tw.div`
  bg-main-even-old
  mb-8
  p-12
  pl-8
  pb-8
  pt-10
  rounded
  border
  border-solid
  border-main-old
  flex
  last:mb-0
`

export interface Props {
  children?: React.ReactNode
}

const TileComponent = (props: Props) => {
  const {children} = props
  return <TwTile>{children}</TwTile>
}

export const Tile = Object.assign(TileComponent, {
  Header,
  Meta
})
